import { HttpParams } from '@angular/common/http';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { isEmpty, isUndefined } from 'lodash';
import { forkJoin, map } from 'rxjs';
import {
  BENEFICIARIES,
  LRC_DEPOSITS,
  TOP_CASH_OUT_LOC,
} from 'src/app/shared/constants/apis-list';
import { PurplWallet } from 'src/app/shared/interfaces/Wallets';
import { DataService } from 'src/app/shared/services';

type OutgoingFunds = {
  name: string;
  currency?: string;
  value?: number;
  percent?: number;
};

@Component({
  selector: 'app-outgoing-funds',
  templateUrl: './outgoing-funds.component.html',
  styleUrls: ['./outgoing-funds.component.scss'],
})
export class OutgoingFundsComponent implements OnInit, OnChanges {
  @Input() wallet: PurplWallet | null = null;

  view: any[] = [280, 280];
  colorScheme: any;

  outGoingFunds: any = {
    domain: ['#66023C', '#808E9E'],
  };

  outgoingFundDetails: any[] = [];

  totalCashout: OutgoingFunds = {
    name: 'Cash outs',
  };

  totalTransfers: OutgoingFunds = {
    name: 'Transfers',
  };

  USERS_COUNT?: number;

  constructor(public dataService: DataService) {}

  ngOnInit(): void {
    this.colorScheme = this.outGoingFunds;
    this.outgoingFundDetails = this.outgoingFundDetails;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes: ', changes);
    if (
      !isEmpty(changes.wallet?.currentValue) &&
      isUndefined(changes.wallet?.previousValue)
    ) {
      this.getAllUsersCount();
      this.initData();
    }
  }

  initData() {
    const cashoutRequest = this.getTotalCompletedCashOut(this.wallet!);
    const transferRequest = this.getTotalTransfers(this.wallet!);

    forkJoin([cashoutRequest, transferRequest]).subscribe((results) => {
      if (!isEmpty(results)) {
        const cashout = results[0];
        const transfer = results[1];

        const totalFunds = cashout.value + transfer.value;
        if (cashout) {
          this.totalCashout = {
            name: 'Cashout',
            value: cashout.value,
            currency: cashout.currency === 'USD' ? '$' : cashout.currency,
            percent: totalFunds > 0 ? (100 * cashout.value) / totalFunds : 0,
          };

          this.outgoingFundDetails = [
            {
              index: 0,
              ...this.totalCashout,
            },
          ];
        }

        if (transfer) {
          this.totalTransfers = {
            name: 'Transfer',
            value: transfer.value,
            currency: transfer.currency === 'USD' ? '$' : transfer.currency,
            percent: totalFunds > 0 ? (100 * transfer.value) / totalFunds : 0,
          };

          this.outgoingFundDetails = [
            ...this.outgoingFundDetails,
            {
              index: 1,
              ...this.totalTransfers,
            },
          ];
        }
      }
    });
  }

  getTotalCompletedCashOut(wallet: PurplWallet) {
    let params: HttpParams = new HttpParams();
    params = params.set('source_id', wallet.id!);
    params = params.set('currency', wallet.currency!);

    return this.dataService
      .fetchData({
        apiUrl: TOP_CASH_OUT_LOC,
        method: 'GET',
        contentType: 'application/json',
        params,
      })
      .pipe(
        map((response) => {
          return response ? response?.total_completed_cash_out_amount : null;
        })
      );
  }

  getTotalTransfers(wallet: PurplWallet) {
    let params: HttpParams = new HttpParams();
    params = params.set('sender__wallet_id', wallet.id!);
    params = params.set('currency', wallet.currency!);

    return this.dataService
      .fetchData({
        apiUrl: LRC_DEPOSITS,
        method: 'GET',
        contentType: 'application/json',
        params,
      })
      .pipe(
        map((response) => {
          return response ? response?.total_funds : null;
        })
      );
  }

  getAllUsersCount() {
    this.dataService
      .fetchData({
        apiUrl:
          BENEFICIARIES +
          `/?wallets__wallet_type_id__in=${this.wallet?.wallet_type_id!}`,
        method: 'GET',
        contentType: 'application/json',
      })
      .pipe(
        map((response) => {
          return response ? response : null;
        })
      )
      .subscribe((response: any) => {
        this.USERS_COUNT = response?.count;
      });
  }
}
